import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function canAccessEnrollmentHealth(id: number) {
  return restApiClient
    .url(constructApiUrl(API.enrollments.canAccessEnrollmentHealth.url, { id }))
    .get<boolean>()
}
